module.exports = __webpack_public_path__ + "static/media/IMG_4295.f29e5f68.PNG";